function get_vh() {
    return window.innerHeight * 0.01
}


document.documentElement.style.setProperty('--vh', get_vh() + 'px');

window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--vh', get_vh() + 'px');
});
window.addEventListener('load', () => {
    document.documentElement.style.setProperty('--vh', get_vh() + 'px');
});
